import * as S from './SimilarHotelPricing.styles';

import {getPriceIntoCommaSeparatedString} from '@stencil/hotels-utils/src/common-utils';

const HotelPricingBlock: React.FC<{
  slashedPrice: number;
  showPrice: number;
  totalRoomCount: number;
}> = ({slashedPrice, showPrice, totalRoomCount}) => (
  <S.SimilarHotelPricingWrapDiv>
    {!!slashedPrice && (
      <S.HotelOldPrice>{getPriceIntoCommaSeparatedString(slashedPrice)}</S.HotelOldPrice>
    )}

    {!!showPrice && (
      <S.HotelFinalPrice>{getPriceIntoCommaSeparatedString(showPrice)}</S.HotelFinalPrice>
    )}

    {!!showPrice && (
      <S.HotelPerNight>
        {totalRoomCount > 0 && (
          <>
            <strong>{`${totalRoomCount} ${totalRoomCount > 1 ? 'rooms ' : 'room '}`}</strong>
            <span>per night</span>
          </>
        )}
      </S.HotelPerNight>
    )}
  </S.SimilarHotelPricingWrapDiv>
);

export default HotelPricingBlock;
